import { logger } from './logger';
import { apiFetch } from './api';
import type { Template } from '../types';

const pendingTemplateSaves = new Map<string, Promise<boolean>>();

// PUTs an updated template to the server and returns the new templates list
// on success (or null on failure). Extracted from the duplicated tail shared
// by handleSaveStageLayout and handleUpdateWidgetConfig, which both did
// "find active template -> mutate its stages -> PUT -> merge into
// templates list" with near-identical bodies.
export async function persistTemplateWidgets(
  templateId: string,
  templatesList: Template[],
  mutateTemplate: (template: Template) => Template
): Promise<Template[] | null> {
  const activeTemplate = templatesList.find((t) => t.id === templateId);
  if (!activeTemplate) return null;

  const updatedTemplate = mutateTemplate(activeTemplate);
  const payload = JSON.stringify(updatedTemplate);
  const requestKey = `${templateId}:${payload}`;

  try {
    let request = pendingTemplateSaves.get(requestKey);
    if (!request) {
      request = apiFetch(`/api/v1/config/templates/${templateId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
      })
        .then((res) => res.ok)
        .finally(() => pendingTemplateSaves.delete(requestKey));
      pendingTemplateSaves.set(requestKey, request);
    }
    if (!(await request)) return null;
    return templatesList.map((t) => (t.id === templateId ? updatedTemplate : t));
  } catch (err) {
    logger.error('Error persisting template widgets:', err);
    return null;
  }
}
